///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, inject } from '@angular/core';
import { AbstractDialogManager } from '../../../dialog-manager/abstract-dialog-manager';
import { Observable } from 'rxjs';
import { DeleteCustomerDialogComponent } from './delete-customer-dialog.component';
import { CustomerDTO } from '../../../generated/shared-types.model';
import { GtthCustomerService } from '../../../services/customer/customer.service';

@Component({
    selector: 'winde-delete-customer-dialog-wrapper-component',
    template: '',
    standalone: false
})
export class DeleteCustomerDialogWrapperComponent extends AbstractDialogManager<CustomerDTO, DeleteCustomerDialogComponent> {
    private readonly customerService = inject(GtthCustomerService);

    constructor() {
        super(DeleteCustomerDialogComponent);
        this.openDialog();
    }

    preparingBaseConfig(): void {
        this.baseConfig.width = '800px';
        this.baseConfig.position = { top: '30px' };
        this.baseConfig.data.id = +this.activatedRoute.snapshot.paramMap.get('id') || null;
    }

    override findById(id: number): Observable<CustomerDTO> {
        return this.customerService.find(id);
    }
}
